<app-authenticating-animation *ngIf="loading"></app-authenticating-animation>
<router-outlet *ngIf="!loading">
</router-outlet>
